import { useMemo } from 'use-memo-one'

import { Network } from '@root/entities/network'
import { TradeSettings } from '@root/entities/trade-settings'

export const useGasSettingsValues = (
  tradeSettings: TradeSettings.TradeSettings,
) => {
  const priorityFee = useMemo(() => {
    if (tradeSettings.network === Network.Solana) {
      return tradeSettings.priorityFee
    }

    if (tradeSettings.network === Network.Ethereum) {
      return tradeSettings.gasPrice ?? tradeSettings.maxGasPrice
    }

    return tradeSettings.gasPrice
  }, [tradeSettings])

  const bribe = useMemo(() => {
    if (tradeSettings.network === Network.Solana && tradeSettings.jitoEnabled) {
      return tradeSettings.jitoTip
    }

    if (tradeSettings.network === Network.Ethereum && !tradeSettings.gasPrice) {
      return tradeSettings.maxPriorityFeePerGas
    }

    return undefined
  }, [tradeSettings])

  const antiMevEnabled = TradeSettings.isAntiMevEnabled(tradeSettings)

  return {
    priorityFee,
    bribe,
    antiMevEnabled,
    slippage: tradeSettings.slippage,
  }
}
